module.exports = __webpack_public_path__ + "img/chevron-down.654de4e5.svg";